import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { Chat } from '../chat/Chat'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ZendeskCommunicationInput')
export class ZendeskCommunication {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('zdc') })
  _id: string

  @Field(() => String)
  @Prop({ type: String })
  ticketNo: string

  @Field(() => Chat)
  @Prop({ type: Chat })
  chatConversation: Chat
}
